import { store } from 'shared/stores/core/decorators';

@store('VIL')
export class VilState {
  // global Vil reference. Note that this is *not* attached to "state" to prevent Vue from converting all public
  // members to Vue Observables.
  vil = null;

  getters = {
    instance: () => this.vil.getInstance()
  };

  constructor ({uScopeApi}) {
    const self = this;

    uScopeApi.plugins.register({
      name: 'us:stores:vil',

      extends: 'uScope',

      dependency: 'vil:wrapper',

      constructor (uScope, vil) {
        self.vil = vil;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/vil/VilState.js